<template>
  <router-view />
</template>

<script>
export default {
  name: 'Services',

  emits: [
    'set-active'
  ],

  created () {
    this.$emit('set-active', 'Services')

    this.$store.dispatch('findAndSetHelpObject', {
      id: 125,
      isInitial: true
    })
  }
}
</script>
